import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify", color: "rgba(232,224,240,0.8)", lineHeight: 1.8 }}>
            Hi, I'm{" "}
            <span className="purple">Mohamed Marwen Meddeb</span>, based in{" "}
            <span className="purple">Rennes, France</span>.
            <br /><br />
            I'm a Software Engineering student at{" "}
            <span className="purple">SUPINFO International University</span>, currently in apprenticeship as a{" "}
            <span className="purple">Full Stack ERP / E-commerce Developer</span> at SEALERIS.
            <br /><br />
            My daily stack revolves around{" "}
            <span className="purple">Odoo, Python, React, Docker</span> and Linux VPS servers.
            I'm passionate about{" "}
            <span className="purple">Cloud computing</span> and{" "}
            <span className="purple">DevSecOps</span> — building systems that are not just functional, but secure and observable.
            <br /><br />
            Outside of tech, here's what I'm into:
          </p>
          <ul style={{ padding: 0, marginTop: "0.5rem" }}>
            <li className="about-activity"><ImPointRight /> Gaming 🎮</li>
            <li className="about-activity"><ImPointRight /> Music 🎵</li>
            <li className="about-activity"><ImPointRight /> Camping 🏕️</li>
          </ul>
          <p style={{ color: "rgba(180,79,255,0.7)", fontStyle: "italic", marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            "If your code works, make it better and cleaner."
          </p>
          <footer className="blockquote-footer">Marwen</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;